(() => {
  const initFreshPackages = (root) => {
    if (!root || root.dataset.freshPackagesInitialized === 'true') return;
    root.dataset.freshPackagesInitialized = 'true';

    const options = Array.from(root.querySelectorAll('[data-fresh-package]'));
    const priceOutputs = root.querySelectorAll('[data-fresh-package-price]');
    const shippingOutputs = root.querySelectorAll('[data-fresh-package-shipping]');
    const titleOutputs = root.querySelectorAll('[data-fresh-package-title]');
    const variantInput = root.querySelector('input[name="id"]');
    const productForm = root.querySelector('form.fresh-conversion-v4__form');

    const selectPackage = (option) => {
      options.forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });

      priceOutputs.forEach((output) => { output.textContent = option.dataset.price || ''; });
      shippingOutputs.forEach((output) => { output.textContent = option.dataset.shipping || ''; });
      const selectedTitle = option.querySelector('.fresh-conversion-v4__package-title')?.textContent?.trim() || '';
      titleOutputs.forEach((output) => { output.textContent = selectedTitle; });

      if (variantInput && option.dataset.variantId) {
        variantInput.value = option.dataset.variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const goDirectlyToCheckout = (event) => {
      event.preventDefault();

      const variantId = variantInput?.value?.trim() || '';
      if (!/^\d+$/.test(variantId)) return;

      const checkoutButtons = Array.from(root.querySelectorAll('button[type="submit"]'))
        .filter((button) => button.form === productForm);

      checkoutButtons.forEach((button) => {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      });

      window.location.assign(`/cart/${variantId}:1?checkout&locale=tr`);
    };

    options.forEach((option) => option.addEventListener('click', () => selectPackage(option)));
    productForm?.addEventListener('submit', goDirectlyToCheckout);

    const initial = options.find((option) => option.classList.contains('is-selected')) || options[0];
    if (initial) selectPackage(initial);
  };

  const boot = () => document.querySelectorAll('[data-fresh-conversion-v4]').forEach(initFreshPackages);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();




